import { DataService } from '../../../services/data_service';
import { ApiService } from '../../../services/api_service';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

interface BeraterProps extends React.ClassAttributes<any> {
    data: any;
}

interface BeraterState {
    formExternerBerater: boolean;
    extern: boolean;
}

export class Berater extends React.Component<BeraterProps, BeraterState> {

    constructor(props: any) {
        super(props);
        this.state = {
            formExternerBerater: false,
            extern: false
        };
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(ApiService) private apiService: ApiService;

    private mails: any = {};

    componentDidMount(): void {
        this.dataService.loadData(
            'user', {}, { fieldList: 'tid, Mail' },
            (data: any) => {
                (this.props.data[IDs.ENT_BERATER] || []).forEach((item: any) => {
                    this.mails[item.tid] = (item.mail || '').toLowerCase();
                });
                (this.props.data[IDs.ENT_REGISTRIERUNG] || []).forEach((item: any) => {
                    this.mails[`r${item.tid}`] = (item.mail || '').toLowerCase();
                });
                ((data || {})['user'] || []).forEach((item: any) => {
                    this.mails[`u${item.tid}`] = (item.Mail || '').toLowerCase();
                });
            },
            IDs.MOD_LEGACY
        );
    }

    render(): JSX.Element {
        const customFormatter = (key: string, value: any, data: any, row: any) => {
            if (key === 'extern') {
                if (value === '') {
                    // extern_orig === 0 || extern_orig === null
                    return 'Interner Berater';
                }
            }
            if (value === undefined || value === null) {
                return '';
            }
            return value;
        };

        const fields = ['name', 'bereich_key', 'login', 'mail', 'password', 'extern'];

        if (!this.state.extern) {
            fields.push('hwk');
        }
        fields.push(...['strasse', 'plz', 'ort', 'telefon', 'plz_bereiche']);

        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_BERATER}
                    module={IDs.MOD_ETOOL_ADMIN}
                    hiddenColumns={['password']}
                    actions={['add', 'edit', 'delete']}
                    formLayout={'flowV2'}
                    customClass={'Custom-ETA'}
                    showColumnsHelp={true}
                    customFormatter={customFormatter}
                    validateField={this.validateField}
                    validRestriction={'stop'}
                    formGroupOrder={[{ fields }]}
                    callBeforeOnFormSave={(data: any, callback: () => void) => {
                        if (data.mail) {
                            this.apiService.call('checkMailExistence', { mail: data.mail, tid: data.tid, entity: IDs.ENT_BERATER, module: IDs.MOD_ETOOL_ADMIN },
                                (res: string, suc: boolean) => {
                                    // console.log(res, suc);
                                    if (suc) {
                                        if (res === '1') {
                                            alert('E-Mail-Adresse existiert bereits.');
                                        } else {
                                            callback();
                                        }
                                    } else {
                                        alert('Server Error');
                                    }
                                }
                            );
                        }
                    }}
                />
            </div>
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        switch (key) {
            case 'extern':
                this.setState({ extern: +value === 1 });
                break;
            case 'mail':
                if (value && value !== '') {
                    if (
                        value.toLowerCase() !== this.mails[data.values.tid || null]
                        && Object.values(this.mails).indexOf(value.toLowerCase()) > -1
                    ) {
                        return 'E-Mail-Adresse existiert bereits.';
                    }
                }
                break;
        }
    }
}
